"use strict";

module.exports = {
  showLoadingIndicator: function showLoadingIndicator(active) {},
  setupAppBarStyle: function setupAppBarStyle() {}
};